export default __webpack_public_path__ + "assets/logo.b617e17f.svg";